import { IHouseCommunicationType } from './index.js'

export interface IHouseCommunication {
  chamber: string
  communicationNumber: number
  communicationType: IHouseCommunicationType
  congressNumber: number
  url: string
}
